
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { HeightChart } from "./HeightChart";
import { WeightChart } from "./WeightChart";
import { MilkChart } from "./MilkChart";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";
import { NoGrowthDataMessage } from "./NoGrowthDataMessage";
import { Baby, LineChart, Milk } from "lucide-react";

interface GrowthTabsProps {
  heightData: any[];
  weightData: any[];
  milkData: any[];
  displayOriginalHeight: number | null;
  displayOriginalWeight: number | null;
  useMetricHeight: boolean;
  useMetricWeight: boolean;
  handleHeightUnitToggle: () => void;
  handleWeightUnitToggle: () => void;
  babyAgeInMonths: number;
}

export function GrowthTabs({
  heightData,
  weightData,
  milkData,
  displayOriginalHeight,
  displayOriginalWeight,
  useMetricHeight,
  useMetricWeight,
  handleHeightUnitToggle,
  handleWeightUnitToggle,
  babyAgeInMonths
}: GrowthTabsProps) {
  const { language } = useLanguage();
  
  return (
    <>
      <Tabs defaultValue="height" className="w-full">
        <TabsList className="grid w-full max-w-md grid-cols-3 mb-6">
          <TabsTrigger value="height" className="flex items-center gap-1">
            <LineChart className="h-4 w-4" />
            {t('statistics.height', language)}
          </TabsTrigger>
          <TabsTrigger value="weight" className="flex items-center gap-1">
            <Baby className="h-4 w-4" />
            {t('statistics.weight', language)}
          </TabsTrigger>
          <TabsTrigger value="milk" className="flex items-center gap-1">
            <Milk className="h-4 w-4" />
            {t('statistics.milk', language)}
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="height">
          <HeightChart 
            heightData={heightData}
            displayOriginalHeight={displayOriginalHeight}
            useMetricHeight={useMetricHeight}
            handleHeightUnitToggle={handleHeightUnitToggle}
            babyAgeInMonths={babyAgeInMonths}
          />
        </TabsContent>
        
        <TabsContent value="weight">
          <WeightChart 
            weightData={weightData}
            displayOriginalWeight={displayOriginalWeight}
            useMetricWeight={useMetricWeight}
            handleWeightUnitToggle={handleWeightUnitToggle}
            babyAgeInMonths={babyAgeInMonths}
          />
        </TabsContent>
        
        <TabsContent value="milk">
          <MilkChart 
            milkData={milkData}
            useMetricUnit={useMetricWeight} // Reuse weight preference for milk
            handleUnitToggle={handleWeightUnitToggle}
            babyAgeInMonths={babyAgeInMonths}
          />
        </TabsContent>
      </Tabs>
      
      <NoGrowthDataMessage heightData={heightData} weightData={weightData} milkData={milkData} />
    </>
  );
}
